module.exports = __webpack_public_path__ + "img/reward-subtitle02.3fc1daee.png";